import { frontmatter as p1 } from 'pages/help/how-livesession-script-works';
import { frontmatter as p2 } from 'pages/help/visitors-excluded';
import { frontmatter as p3 } from 'pages/help/will-livesession-slow-down-loading-of-my-website';
import { frontmatter as int1 } from 'pages/help/google-analytics-integration';
import { frontmatter as int2 } from 'pages/help/intercom-integration';
import { frontmatter as int3 } from 'pages/help/segment-integration';
import { frontmatter as int4 } from 'pages/help/livechat-integration';
import { frontmatter as int5 } from 'pages/help/help-scout-integration';
import { frontmatter as int6 } from 'pages/help/crisp-integration';
import { frontmatter as int7 } from 'pages/help/olark-integration';
import { frontmatter as int8 } from 'pages/help/drift-integration';
import { frontmatter as int9 } from 'pages/help/zendesk-integration';
import { frontmatter as int10 } from 'pages/help/sentry-integration';
import { frontmatter as int11 } from 'pages/help/bugsnag-integration';
import { frontmatter as int12 } from 'pages/help/survicate-integration';
import { frontmatter as int13 } from 'pages/help/errorception-integration';
import { frontmatter as int14 } from 'pages/help/heap-integration';
import { frontmatter as int15 } from 'pages/help/mixpanel-integration';
import { frontmatter as int16 } from 'pages/help/user-integration';
import { frontmatter as int17 } from 'pages/help/dashly-integration';
import { frontmatter as int18 } from 'pages/help/google-optimize-integration';
import { frontmatter as int19 } from 'pages/help/shopify-integration';

import { frontmatter as pr1 } from 'pages/help/gdpr';
import { frontmatter as pr2 } from 'pages/help/opt-out-cookie';
import { frontmatter as pr3 } from 'pages/help/ccpa';
import { frontmatter as t2 } from 'pages/help/how-to-record-keystrokes';
import { frontmatter as i1 } from 'pages/help/how-install-on-bigcommerce';
import { frontmatter as i2 } from 'pages/help/how-install-on-shopify';
import { frontmatter as i3 } from 'pages/help/how-install-on-wix';
import { frontmatter as i4 } from 'pages/help/how-install-on-wordpress';
import { frontmatter as i5 } from 'pages/help/how-install-with-google-tag-manager';
import { frontmatter as i6 } from 'pages/help/how-to-install-livesession-script';
import { frontmatter as i7 } from 'pages/help/gatsby-integration';
import { frontmatter as i8 } from 'pages/help/react-and-angular-integration';
import { frontmatter as t1 } from 'pages/help/how-to-check-if-my-tracking-script-works';
import { frontmatter as t3 } from 'pages/help/user-identification-custom-properties';
import { frontmatter as t4 } from 'pages/help/how-to-anonymize-sensitive-page-content';
import { frontmatter as t5 } from 'pages/help/does-livesession-works-on-internal-servers';
import { frontmatter as t6 } from 'pages/help/how-to-connect-events-from-google-analytics';
import { frontmatter as t7 } from 'pages/help/how-to-connect-events-from-segment';
import { frontmatter as p4 } from 'pages/help/how-to-exclude-recording';
import { frontmatter as p5 } from 'pages/help/how-to-pause-recording';
import { frontmatter as p6 } from 'pages/help/what-is-a-session';
import { frontmatter as p7 } from 'pages/help/work-with-mobile-apps';
import { frontmatter as p8 } from 'pages/help/does-livesession-record-iframes';
import { frontmatter as p9 } from 'pages/help/how-retention-and-quota-limits-work';
import { frontmatter as p10 } from 'pages/help/how-inactivity-is-calculated';
import { frontmatter as p11 } from 'pages/help/how-to-assign-and-edit-user-roles';
import { frontmatter as p12 } from 'pages/help/how-to-track-users-across-multiple-subdomains';
import { frontmatter as p13 } from 'pages/help/how-does-the-search-work';
import { frontmatter as p14 } from 'pages/help/how-does-the-timeline-work';
import { frontmatter as p15 } from 'pages/help/how-do-the-custom-events-work';
import { frontmatter as p16 } from 'pages/help/how-do-the-clickmaps-work';
import { frontmatter as p17 } from 'pages/help/how-to-use-inspect-mode';
import { frontmatter as p18 } from 'pages/help/how-to-set-segment-summary-email';
import { frontmatter as p19 } from 'pages/help/how-do-the-funnels-work';
import { frontmatter as p20 } from 'pages/help/why-is-my-recording-broken';
import { frontmatter as p21 } from 'pages/help/what-is-minimum-time-on-page';
import { frontmatter as p22 } from 'pages/help/how-to-export-data-from-livesession';

const product = [
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
  p7,
  p8,
  p9,
  p10,
  p11,
  p12,
  p13,
  p14,
  p15,
  p16,
  p17,
  p18,
  p19,
  p20,
  p21,
  p22,
];

const integrations = [
  int1,
  int2,
  int3,
  int19,
  int4,
  int5,
  int6,
  int7,
  int8,
  int9,
  int10,
  int11,
  int12,
  int13,
  int14,
  int15,
  int16,
  int17,
  int18,
];

const privacy = [pr1, pr3, pr2];

const getStarted = [i6, i4, i5, i2, i3, i1, i7, i8];

const developer = [t1, t3, t2, t4, t5, t6, t7];

const all = [...getStarted, ...integrations, ...developer, ...product, ...privacy];

export { product, integrations, privacy, getStarted, developer, all };
